export enum DeploymentStatus {
    Waiting = 'waiting',
    Processing = 'processing',
    Building = 'building',
    Ready = 'ready',
    Canceled = 'canceled',
    Failed = 'failed',
}